<template>
  <button @click.stop="handleClick" class="ts-x-black bg-grey-200"></button>
</template>

<script lang="ts" setup>
  import { defineEmits } from 'vue'

  interface Emits {
    (e: 'close'): void
  }

  // emit
  const emit = defineEmits<Emits>()

  // handlers
  const handleClick = () => {
    emit('close')
  }
</script>

<style scoped></style>
